// src/components/RequireAuth.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const token = localStorage.getItem('access_token');
  const location = useLocation();

  if (!token) {
    // Redirect them to /signin, but save the current location
    // so they can be sent back after login.
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
}
